export default "__VITE_ASSET__h$FDFeL___"